import Icon from '../../../Icon/Icon';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalOnDelete from '../../../Modal/ModalOnDelete';
import ScreensList from '../ForecastMetrics/ScreensList';
import { useForecast } from '../../../../contexts/ForecastContext';

const ScreenDiagnostics = ({
    setSelectedScreensLocal,
    selectedScreens = [],
    selectedScreensLocal = [],
    onClearScreensWithoutProvider,
    onUpdateSelectedScreens,
}) => {
    const { forecast: metrics = {} } = useForecast();
    const { t } = useTranslation();
    const [screensToDelete, setScreensToDelete] = useState([]);
    const [isActive, setIsActive] = useState(false);
    const screensWithoutProvider = metrics.screensWithoutProvider || [];

    const handleInputChange = (isChecked, idScreen) => {
        if (isChecked) {
            setScreensToDelete([...screensToDelete, idScreen]);
            return;
        }
        setScreensToDelete((prev) =>
            prev.filter((screenItem) => screenItem !== idScreen)
        );
    };

    const handleAllInputChange = (isChecked) => {
        const inputs = document.getElementsByName(
            'individual-screensWithoutAudience-input'
        );
        if (isChecked) {
            const allScreens = screensWithoutProvider.map(
                (screen) => screen.id
            );
            setScreensToDelete(allScreens);
            inputs.forEach((input) => {
                input.checked = true;
            });
        } else {
            setScreensToDelete([]);
            inputs.forEach((input) => {
                input.checked = false;
            });
        }
    };

    const handleModal = () => setIsActive((prev) => !prev);
    const handleCancel = () => handleModal();

    const handleConfirm = () => {
        if (!screensToDelete.length) return;
        let screensWithAudience = [...selectedScreens];
        screensToDelete.forEach((id) => {
            screensWithAudience = screensWithAudience.filter(
                (screen) => screen.id !== id
            );
        });
        onClearScreensWithoutProvider?.();
        if (onUpdateSelectedScreens) {
            onUpdateSelectedScreens(screensWithAudience);
        } else {
            setSelectedScreensLocal(screensWithAudience);
        }
        handleModal();
    };

    return (
        <>
            <div
                className={`mt-8 ${
                    screensWithoutProvider.length > 0 ? 'block' : 'hidden'
                } flex flex-col rounded-lg bg-red-100 p-2`}>
                <div className="my-4">
                    <span className="font-bold text-red-600">
                        <Icon
                            name="exclamation-triangle"
                            fixedWidth
                            className="mr-2 text-red-300"
                        />{' '}
                        {t(
                            'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience'
                        )}
                        :
                    </span>
                    <br />
                    <span className="text-gray-700 font-light">
                        {t(
                            'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience-explain'
                        )}
                    </span>
                </div>
                <div className="flex justify-between">
                    <input
                        onChange={(e) => handleAllInputChange(e.target.checked)}
                        name={'all-screensWithoutAudience-input'}
                        type="checkbox"
                        className="h-4 w-4 text-blue-600 focus:ring-0 border-gray-300 mt-2 rounded"
                    />
                    <button
                        className="bg-red-700 hover:bg-red-900 text-white rounded transition-colors duration-300 ease-in-out font-light text-sm p-1 focus:outline-none w-5/12"
                        onClick={handleModal}>
                        {t(
                            'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience-unselect'
                        )}
                    </button>
                </div>
                <ol className="text-xs mt-4 text-xs ">
                    {screensWithoutProvider.map((screen) => (
                        <div className="flex flex-row mt-1" key={screen.id}>
                            <input
                                onChange={(e) =>
                                    handleInputChange(
                                        e.target.checked,
                                        screen.id
                                    )
                                }
                                name={'individual-screensWithoutAudience-input'}
                                id={screen.id}
                                type="checkbox"
                                className="h-4 w-4 text-blue-600 mr-2 focus:ring-0 border-gray-300 rounded"
                            />
                            <li className="text-gray-500 ">
                                <label htmlFor={screen.id}>
                                    {screen.name} ({screen.id})
                                </label>
                            </li>
                        </div>
                    ))}
                </ol>
            </div>
            <div
                className={`mt-6 flex flex-col ${
                    metrics.screensUsed?.length > 0 &&
                    metrics.screensNotUsed?.length > 0
                        ? 'block'
                        : 'hidden'
                }`}>
                <ScreensList
                    screens={metrics.screensUsed || []}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-used'
                    )}
                    icon={{ type: 'fal', name: 'check-circle' }}
                    description={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-used-explain'
                    )}
                    color={'blue-400'}
                    selectedScreensLocal={selectedScreensLocal}
                    setSelectedScreensLocal={setSelectedScreensLocal}
                />
            </div>
            <div
                className={`mt-6 flex flex-col ${
                    metrics.screensNotUsed?.length > 0 ? 'block' : 'hidden'
                }`}>
                <ScreensList
                    screens={metrics.screensNotUsed || []}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-not-used'
                    )}
                    icon={{ type: 'fad', name: 'exclamation-triangle' }}
                    description={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-not-used-explain'
                    )}
                    color={'yellow-300'}
                    selectedScreensLocal={selectedScreensLocal}
                    setSelectedScreensLocal={setSelectedScreensLocal}
                />
            </div>

            <div
                className={`mt-6 flex flex-col ${
                    metrics.notMatchingScreens?.length > 0 ? 'block' : 'hidden'
                }`}>
                <span className="font-bold">
                    <Icon
                        name="exclamation-triangle"
                        className="mr-1 text-yellow-300"
                    />{' '}
                    {t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience-match'
                    )}
                    :
                </span>
                <span className="font-light mb-4">
                    {t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience-match-explain'
                    )}
                    .
                </span>
                <ul>
                    {(metrics.notMatchingScreens || []).map((screen) => (
                        <span
                            key={screen.id}
                            className="font-light text-gray-600 block">
                            {screen.name} ({screen.id})
                        </span>
                    ))}
                </ul>
            </div>
            <ModalOnDelete
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
                isActive={isActive}
                handleModal={handleModal}
                title={t(
                    'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience'
                )}
                body={t(
                    'sections.campaigns.new-campaign.wizard-audiences.forecast.screens-without-audience-confirm'
                )}
            />
        </>
    );
};

export default ScreenDiagnostics;
